import React, { useState } from "react";
import GenerateQuotationApi from "./ApiQuotation/GenerateQuotationApi";
import GenerateQuotationSoftware from "./SoftwareQuotation/GenerateSoftwareQuotation";
import { Code, Monitor } from "lucide-react";

function GenerateQuotation() {
  const [quotationFor, setQuotationFor] = useState("api");

  return (
    <div className="mx-auto w-full bg-white px-4 py-6">
      {/* Header - Kept intact */}
      <div className="border-b pb-4">
        <h1 className="text-3xl font-black text-blue-900 italic">
          IDS<span className="text-green-500">Pay</span>{" "}
          <span className="text-slate-500 font-light not-italic">
            Quotation Generation Portal
          </span>
        </h1>
      </div>

      {/* Elegant Segmented Control Tab Switcher */}
      <div className="mt-2">
        <div className="inline-flex rounded-xl bg-slate-100 p-1.5 shadow-inner border border-slate-200/70">
          <button
            type="button"
            onClick={() => setQuotationFor("api")}
            className={`relative flex items-center justify-center gap-2.5 rounded-lg px-6 py-2.5 text-sm font-semibold transition-all duration-300 ease-out ${
              quotationFor === "api"
                ? "bg-blue-600 text-white shadow-md ring-1 ring-blue-700/50"
                : "text-slate-500 hover:text-slate-800 hover:bg-slate-200/60"
            }`}
          >
            <Code className={`h-4 w-4 transition-colors ${quotationFor === "api" ? "text-white" : "text-slate-400"}`} />
            For API
          </button>
          
          <button
            type="button"
            onClick={() => setQuotationFor("software")}
            className={`relative flex items-center justify-center gap-2.5 rounded-lg px-6 py-2.5 text-sm font-semibold transition-all duration-300 ease-out ${
              quotationFor === "software"
                ? "bg-blue-600 text-white shadow-md ring-1 ring-blue-700/50"
                : "text-slate-500 hover:text-slate-800 hover:bg-slate-200/60"
            }`}
          >
            <Monitor className={`h-4 w-4 transition-colors ${quotationFor === "software" ? "text-white" : "text-slate-400"}`} />
            For Software
          </button>
        </div>
      </div>

      {/* Dynamic Form Area Wrapper */}
      <div className="rounded-2xl border border-slate-100 bg-slate-50/50 pb-6 shadow-sm transition-all duration-300">
        {quotationFor === "api" ? (
          <GenerateQuotationApi />
        ) : (
          <GenerateQuotationSoftware />
        )}
      </div>
    </div>
  );
}

export default GenerateQuotation;